import React from 'react'
import { PullToRefreshContainer } from '@mobi/component-library/Common/PullToRefreshContainer'
import { useScrollRestoreOverride } from '@core/Areas/AppHeader/Components/ScrollRestoration/hooks'
import { FeedContainerStyled } from '@core/Areas/FollowMe/Components/Common/FollowMe.styles'
import { SkeletonLoader } from '@core/Areas/FollowMe/Components/Common/SkeletonLoader'
import { SharedBetCard } from '@core/Areas/FollowMe/Components/Common/SharedBetCard'
import { SortFeed } from '@core/Areas/FollowMe/Components/Common/SortFeed'
import { useSharedBetsData } from '@core/Areas/FollowMe/hooks/useSharedBetsData'
import type { SortFilter, SortOrder } from '@core/Areas/FollowMe/types'
import { QuickShareButton } from '@core/Areas/FollowMe/Components/ExploreFeed/Components/QuickShareButton'
import { EmptyMessage } from '@core/Areas/FollowMe/Components/Common/EmptyMessage'

let sessionSortOrder: SortOrder = 'sortAsc'
let sessionSortFilder: SortFilter = 'JumpTime'

export const ExploreFeed: React.FC = () => {
  const [sortOrder, setSortOrder] = React.useState<SortOrder>(sessionSortOrder)
  const [sortFilter, setSortFilter] = React.useState<SortFilter>(sessionSortFilder)

  React.useEffect(() => {
    sessionSortOrder = sortOrder
    sessionSortFilder = sortFilter
  }, [sortFilter, sortOrder])

  const { isLoading, data, refetch, isRefetching, LoadMoreButton, isEmptyState } =
    useSharedBetsData({ sortFilter, sortOrder, feedType: 'explore' })

  const shouldRenderLoader = isLoading || isRefetching || !data
  useScrollRestoreOverride({ hasPageLoaded: !shouldRenderLoader && !isEmptyState })

  if (isEmptyState) {
    return (
      <>
        <EmptyMessage
          messageType='explore'
          title='No Shared Bets'
          description={`There aren't any bets shared\n right now. Be the first to share\n yours!`}
        />

        <QuickShareButton />
      </>
    )
  }

  return (
    <>
      <SortFeed
        sortFilter={sortFilter}
        sortOrder={sortOrder}
        handleSortFilterChange={setSortFilter}
        handleSortOrderChange={setSortOrder}
      />
      {shouldRenderLoader ? (
        <FeedContainerStyled>
          <SkeletonLoader />
        </FeedContainerStyled>
      ) : (
        <PullToRefreshContainer onRefresh={refetch}>
          <FeedContainerStyled>
            {data?.pages.map(feedPage =>
              feedPage.map(sharedBet => (
                <SharedBetCard key={sharedBet.postId} sharedBet={sharedBet} />
              ))
            )}

            <LoadMoreButton />
          </FeedContainerStyled>
        </PullToRefreshContainer>
      )}

      <QuickShareButton />
    </>
  )
}
